import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';

const SectionImageBlock = styled(ImageBlock)`
  ${paddingBuilder.all(0)}
  height: 104vw;

  order: 0;

  ${tablet768`
    ${paddingBuilder.all(0)}

    height: auto;

    flex: 1 1 50%;
    order: 1;
  `}
`;

SectionImageBlock.displayName = 'SectionImageBlock';

export default SectionImageBlock;
